export enum AuthMethod {
  Email = 'EMAIL',
  Facebook = 'FACEBOOK',
  Google = 'GOOGLE',
  LoginAsUser = 'LOGIN_AS_USER',
}
